import Vue from 'vue';
import checkBusinessTransformer from './../../transformers/custom/checkBusiness';

const success = (business, resolve) => {
  resolve(checkBusinessTransformer.fetch(business));
};

const failed = (errors, reject) => {
  reject(checkBusinessTransformer.fetch(errors));
};

export default business => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('auth/check_business', business)
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/auth/checkBusiness.js